import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import querystring from 'query-string';
import { requestBizumOrder } from '../store/payments';
import { resetTime } from '../store/globals';
import PaymentSharedFields from '../components/PaymentSharedFields';
import Loader from '../components/Loader';
import LocalRedirect from '../components/LocalRedirect';


const { token, session_id, PayerID } = querystring.parse(window.location.search); 

class PaymentPayPalCallback extends Component {

  constructor(props) {
    super(props);
    let initialBillTo = {
      email: '',
      first_name: '',
      last_name: '',
      phone: '',
      loyalty: ''
    };

    if (this.props.payments.bill_to !== null) {
      const { email, first_name, last_name, phone, loyalty } = this.props.payments.bill_to;

      initialBillTo = {
        email, first_name, last_name, phone, loyalty
      };
    }

    this.state = {
      bill_to: initialBillTo,
      valid: true
    };
  }

  componentDidMount() {
    this.props.resetTime();
    this.props.requestBizumOrder(session_id, token,PayerID, this.state.bill_to, this.state.bill_to.loyalty);
  }

  render() {
    const { isLoading, paymentResponse } = this.props.payments;
    if (typeof paymentResponse.tickets_confirmation !== 'undefined' && paymentResponse.tickets_confirmation !== null && paymentResponse.tickets_confirmation.status === 0) {
      return <LocalRedirect to="/confirmacion" />;
    }

    return (
      <Fragment>
        <div className="container container--mid-large payments">
          {isLoading && <Loader />}

          <div className={isLoading ? 'blur-overlay' : ''}>
            <PaymentSharedFields
              bill_to={this.state.bill_to}
              onInputChange={this.handleInputChange}
              onInputBlur={this.handleInputBlur}
            />
          </div>
        </div>    
      </Fragment>
    );
  }
}
const mapStateToProps = ({ payments }) => {
  return {
    payments
  };
};

export default connect(
  mapStateToProps, { requestBizumOrder, resetTime }
)(PaymentPayPalCallback);
